import { routes } from 'appConstants';

export const navItems: { path: string; title: string; unsetCase: boolean }[] = [
  routes.aboutUs2.root,
  routes.explore.root,
  routes.custodyInfo.root,
  routes.defi.root,
];
